import { AuthAdapter as CoreAuthAdapter } from '@core/adapters';

export class AuthAdapter extends CoreAuthAdapter {}
